import ms from "ms";
import HttpService from "services/HttpService";
import getClientUniqueId from "helpers/getClientUniqueId";

import ENV from "../constants/ENV";
import HEADERS from "../constants/HEADERS";
import COUNTRY from "../constants/COUNTRY";
import MEMBER_ROLES from "../constants/MEMBER_ROLES";

const ApiClientViewTracker = new HttpService({
  baseURL: ENV.VIEW_TRACKER_ENDPOINT,
  timeout: ms(ENV.API_TIMEOUT_DURATION as ms.StringValue) / 2
});

ApiClientViewTracker.setHeader(HEADERS.application, COUNTRY.application);
ApiClientViewTracker.setHeader(HEADERS.appVersion, __BUILD_VERSION__);
ApiClientViewTracker.setHeader(HEADERS.memberRole, MEMBER_ROLES.user);
ApiClientViewTracker.setHeader(HEADERS.clientUnique, getClientUniqueId());
ApiClientViewTracker.setHeader(HEADERS.acceptLanguage, COUNTRY.acceptLanguage);

ApiClientViewTracker.addResponseInterceptor(
  "view-tracker-response-interceptor",
  (response) => {
    const transformedResponse = Object.assign(
      {},
      {
        data: null
      },
      response.data
    );
    return transformedResponse;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default ApiClientViewTracker;
